import { Directive } from '@angular/core';
import { MatLegacyAutocompleteTrigger as MatAutocompleteTrigger } from '@angular/material/legacy-autocomplete';

@Directive({
    selector: '.contenteditable[matAutocomplete]',
    standalone: true
})
export class ContenteditableTriggerDirective extends MatAutocompleteTrigger {}
